// 2026-09-30 addition — shown after a forced first login (force_password_
// change=true in the login response). Calls /api/auth/change-password with
// forced: true (no current_password needed), same shape as
// labariumchatbotsv2's own change-password flow.
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { extractErrorDetail } from "./validators";
import { Box, Typography, TextField, Button, Alert, CircularProgress } from "@mui/material";
import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:8000";

export default function ChangePassword() {
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (newPassword.length < 8) return setError("Password must be at least 8 characters.");
    if (newPassword !== confirm) return setError("Passwords don't match.");
    setLoading(true);
    try {
      await axios.post(
        `${API}/api/auth/change-password`,
        { new_password: newPassword, forced: true },
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } },
      );
      navigate("/");
    } catch (err) {
      setError(extractErrorDetail(err, "Failed to update password."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", bgcolor: "#f4f7ff" }}>
      <Box sx={{ width: 420, p: 4, borderRadius: "16px", bgcolor: "#fff", boxShadow: "0 24px 60px rgba(0,31,77,0.12)" }}>
        <Typography sx={{ fontWeight: 700, fontSize: 20, mb: 1 }}>Set your password</Typography>
        <Typography sx={{ fontSize: 14.5, color: "#64748b", mb: 3 }}>
          For security, you need to set your own password before continuing.
        </Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Box component="form" onSubmit={handleSubmit} noValidate>
          <TextField label="New password" type="password" size="small" fullWidth required
            value={newPassword} onChange={(e) => setNewPassword(e.target.value)} sx={{ mb: 2.5 }} autoFocus />
          <TextField label="Confirm new password" type="password" size="small" fullWidth required
            value={confirm} onChange={(e) => setConfirm(e.target.value)} sx={{ mb: 3 }} />
          <Button type="submit" fullWidth variant="contained" disabled={loading} sx={{ py: 1.3, fontWeight: 700, textTransform: "none" }}>
            {loading ? <CircularProgress size={20} sx={{ color: "#fff" }} /> : "Set Password & Continue"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
